// extracted by mini-css-extract-plugin
export default {"box__icons":"Projects_box__icons__6ZfyR","box__heading":"Projects_box__heading__vYcUG","box__para":"Projects_box__para__WkEqg","box__footer":"Projects_box__footer__RnbG1"};